import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OptionType } from '../core/enums/enums';
import { SharedModule } from '../shared/shared.module';
import { DischargedItineraryComponent } from './components/discharged-itinerary/discharged-itinerary.component';
import { ExceptionFormComponent } from './components/exception-form/exception-form.component';
import { ItineraryActionsComponent } from './components/itinerary-actions/itinerary-actions.component';
import { OptionsComponent } from './components/options/options.component';
import { SegmentsComponent } from './components/segments/segments.component';
import { ItineraryInfoComponent } from './containers/itinerary-info/itinerary-info.component';
import { OperationLogComponent } from './containers/operation-log/operation-log.component';
import { SearchResultComponent } from './containers/search-result/search-result.component';
import { PnrEffects } from './effects/pnr.effects';
import { PnrReducer } from './reducers/pnr.reducer';
import { SearchResultRoutingModule } from './search-result-routing.module';
import { AirportIconsService } from './services/airport-icons.service';
import { CheckAndUncheckService } from './services/check-and-uncheck.service';
import { OperationTableComponent } from './components/operation-table/operation-table.component';
import { OperationContentComponent } from './components/operation-content/operation-content.component';
import { InstructionMessageActionSelectedComponent } from './components/instruction-message-action-selected/instruction-message-action-selected.component';
import { SyncTicketFormComponent } from './components/sync-ticket-form/sync-ticket-form.component';
import { PnrHistoryComponent } from './containers/pnr-history/pnr-history.component';
import { AirCompanyNoteComponent } from './containers/air-company-note/air-company-note.component';
import { TicketHistoryComponent } from './containers/ticket-history/ticket-history.component';
import { CancellationQuoteResumeModule } from '../components/cancellation-quote-resume/cancellation-quote-resume.module';
import { WaiverOsiModule } from '../components/waiver-osi/waiver-osi.module';
import { SeatsEffects } from './effects/seats.effects';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { IntegrationsService } from '../integrations/services/integrations.service';
import { ItineraryHistoryComponent } from './containers/itinerary-history/itinerary-history.component';
import { VoidTransactionModalComponent } from './containers/itinerary-info/components/void-transaction-modal/void-transaction-modal.component';
import { SettingsModule } from '../settings/settings.module';
import { ReRouteModalModule } from '../re-route/components/re-route-modal/re-route-modal.module';
import { BookingCredentialsModule } from '../components/booking-credentials/booking-credentials.module';
import { PipesModule } from '../core/pipes/pipes.module';
import { OagFltStatusModalComponent } from './containers/itinerary-info/components/oag-flt-status-modal/oag-flt-status-modal.component';
import { LogInLogModalComponent } from './containers/itinerary-info/components/log-in-log-modal/log-in-log-modal.component';
import {
  AlertModule,
  BlockModule,
  CheckBoxModule,
  FlightModule,
  FullAlertModule,
  InputFieldModule,
  InputSelectModule,
  InputSubmitModule,
  ModalModule,
  PassengersModule,
  SpinnerModule,
  TextareaModule,
  TooltipModule,
  ItineraryResumeModule,
  AvailableActionModalModule,
  CheckRadioModule,
  TicketHistoriesModule,
  InputSelectAddonModule,
  RemarksModule,
  TitleModule
} from '../components';

@NgModule({
  declarations: [
    SearchResultComponent,
    OptionsComponent,
    ItineraryInfoComponent,
    ItineraryActionsComponent,
    DischargedItineraryComponent,
    OperationLogComponent,
    ExceptionFormComponent,
    SegmentsComponent,
    OperationTableComponent,
    OperationContentComponent,
    InstructionMessageActionSelectedComponent,
    SyncTicketFormComponent,
    PnrHistoryComponent,
    AirCompanyNoteComponent,
    TicketHistoryComponent,
    ItineraryHistoryComponent,
    VoidTransactionModalComponent,
    OagFltStatusModalComponent,
    LogInLogModalComponent
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    MatExpansionModule,
    SearchResultRoutingModule,
    InputSelectAddonModule,
    MatDividerModule,
    SharedModule,
    StoreModule.forFeature(OptionType.SearchResult, PnrReducer),
    EffectsModule.forFeature([PnrEffects, SeatsEffects]),
    FormsModule,
    PassengersModule,
    BlockModule,
    ModalModule,
    AlertModule,
    FullAlertModule,
    SpinnerModule,
    TooltipModule,
    CheckBoxModule,
    CheckRadioModule,
    CancellationQuoteResumeModule,
    InputFieldModule,
    InputSelectModule,
    FlightModule,
    TextareaModule,
    ItineraryResumeModule,
    WaiverOsiModule,
    InputSubmitModule,
    AvailableActionModalModule,
    ReactiveFormsModule,
    TicketHistoriesModule,
    RemarksModule,
    SettingsModule,
    ReRouteModalModule,
    BookingCredentialsModule,
    TitleModule,
    PipesModule
  ],
  exports: [SegmentsComponent],
  providers: [CheckAndUncheckService, AirportIconsService, IntegrationsService]
})
export class SearchResultModule {}
